'use client';

import { useCallback } from 'react';
import { useMutation, useQuery } from 'convex/react';
import { api } from '@/convex/_generated/api';
import type { Id } from '@/convex/_generated/dataModel';

export function useRealtimeVoiceFailureStatus(args: {
  open: boolean;
  orgThreadId?: Id<'orgThreads'> | null;
  sessionId: string | null;
}) {
  const { orgThreadId, sessionId } = args;
  const pendingFailure = useQuery(
    api.voice.realtime_status_outbox.pendingFailure,
    args.open && orgThreadId && sessionId ? { orgThreadId, sessionId } : 'skip'
  );
  const acknowledge = useMutation(
    api.voice.realtime_status_outbox.acknowledgeFailure
  );
  const acknowledgeFailure = useCallback(
    async (event: { turnId: string; sessionId?: string }) => {
      if (!orgThreadId || !event.sessionId || !event.turnId) return;
      await acknowledge({
        orgThreadId,
        sessionId: event.sessionId,
        eventId: event.turnId,
      });
    },
    [acknowledge, orgThreadId]
  );
  return { pendingFailure, acknowledgeFailure };
}
